import React from "react";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { UserDetailsService } from "../../../services";
import { DRAFT_STORAGE_KEY, SOCIAL_SIGNUP_MODES } from "../../../constants";
import AuthAnaltyicsEvent from "@/services/analytics/main/authentication";
import GoogleImage from "@/images/icons/google.svg";
import { saveToSessionStorage } from "@/util/storage";

export const getGoogleUserProfile = async accessToken => {
  if (!accessToken) {
    console.error("Access token is missing");
    return null;
  }

  try {
    const userInfoResponse = await axios.get(
      "https://www.googleapis.com/oauth2/v1/userinfo",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json"
        }
      }
    );

    return userInfoResponse.data;
  } catch (error) {
    console.error("Failed to fetch Google user profile:", error);
    return null;
  }
};

const GoogleSignInBtn = ({
  socialCallback,
  buttonLabel,
  textFor = "",
  className = "google"
}: {
  socialCallback: any;
  buttonLabel?: string;
  textFor?: string;
  className?: string;
}) => {
  const googleLogin = useGoogleLogin({
    onSuccess: async tokenResponse => {
      socialCallback(SOCIAL_SIGNUP_MODES.GOOGLE, tokenResponse.access_token);

      const userProfile = await getGoogleUserProfile(
        tokenResponse.access_token
      );

      if (userProfile) {
        const draftData = {
          formikValues: { fullname: userProfile?.name }
        };

        saveToSessionStorage(DRAFT_STORAGE_KEY, draftData);
      }
    },
    onError: errorResponse =>
      socialCallback(SOCIAL_SIGNUP_MODES.GOOGLE, errorResponse),
    onNonOAuthError: () =>
      AuthAnaltyicsEvent.authenticationMethod({
        isLogin: textFor === "login",
        method: SOCIAL_SIGNUP_MODES.GOOGLE
      })
  });
  return (
    <button onClick={() => googleLogin()} className={className}>
      {buttonLabel ? buttonLabel : <img src={GoogleImage} alt="google" />}
    </button>
  );
};
export default GoogleSignInBtn;
